import { c as _c } from "react/compiler-runtime";
import { TourCardHotelFurthermoreDrawerPropertiesType } from "@website/accommodation-ui/tour-card/tour-card-hotel/tour-card-hotel-furthermore/tour-card-hotel-furthermore-drawer/types";
import { Loading } from "@website/ui/loading";
import dynamic from "next/dynamic";
import { FC } from "react";
const TourCardHotelFurthermoreDrawerTabpanel = dynamic(() => import("./tour-card-hotel-furthermore-drawer-tabpanel").then(({
  TourCardHotelFurthermoreDrawerTabpanel
}) => TourCardHotelFurthermoreDrawerTabpanel));
const TourCardHotelFurthermoreDrawerTablist = dynamic(() => import("./tour-card-hotel-furthermore-drawer-tablist").then(({
  Tablist
}) => Tablist), {
  loading: () => <div className="flex items-center justify-center p-4">
        <Loading />
      </div>
});
const TourCardHotelFurthermoreDrawerPrice = dynamic(() => import("./tour-card-hotel-furthermore-drawer-price").then(({
  TourCardHotelFurthermoreDrawerPrice
}) => TourCardHotelFurthermoreDrawerPrice));
export const TourCardHotelFurthermoreDrawer: FC<TourCardHotelFurthermoreDrawerPropertiesType> = properties => {
  const $ = _c(12);
  const {
    isOpen,
    onClose,
    hotel,
    isDomestic,
    onSelectTab
  } = properties;
  let t0;
  if ($[0] !== hotel) {
    t0 = hotel || {};
    $[0] = hotel;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    id
  } = t0;
  const t1 = `shadow-16 bg-on-color-high-emphasis fixed left-0 top-0 z-40 flex h-full w-screen flex-col justify-between transition-all md:max-w-[30rem] xl:max-w-[52rem] ${isOpen ? "translate-x-0 opacity-100" : "-translate-x-full opacity-0"} `;
  let t2;
  if ($[2] !== id || $[3] !== isDomestic || $[4] !== isOpen || $[5] !== onClose || $[6] !== onSelectTab || $[7] !== properties) {
    t2 = isOpen && <><TourCardHotelFurthermoreDrawerTablist isDomestic={isDomestic} onClose={onClose} onSelect={onSelectTab} /><TourCardHotelFurthermoreDrawerTabpanel id={id.toString()} isDomestic={isDomestic} /><TourCardHotelFurthermoreDrawerPrice source="HotelDetails" {...properties} /></>;
    $[2] = id;
    $[3] = isDomestic;
    $[4] = isOpen;
    $[5] = onClose;
    $[6] = onSelectTab;
    $[7] = properties;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <section className={t1}>{t2}</section>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};